import useSWR from 'swr'
import type { ShortlistEntry } from 'views/ProjectsV2/Shortlist/types'

const extractList = (body: any): ShortlistEntry[] => {
  if (Array.isArray(body)) return body
  if (Array.isArray(body?.data)) return body.data
  if (Array.isArray(body?.entries)) return body.entries
  if (Array.isArray(body?.data?.entries)) return body.data.entries
  return []
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text()
      throw new Error(`GET failed: ${res.status} ${text}`)
    }
    const body = await res.json()
    return extractList(body)
  })

type Options = {
  /** When true, suppress focus revalidation (use while admin has unsaved edits). */
  paused?: boolean
}

const useShortlistEntries = (
  dealId: string | null,
  roundId: number | null,
  options: Options = {},
) => {
  const key =
    dealId && typeof roundId === 'number' && Number.isFinite(roundId)
      ? `${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/deals/${dealId}/shortlist/rounds/${roundId}/entries`
      : null

  const { data, error, isLoading, mutate } = useSWR<ShortlistEntry[]>(
    key,
    fetcher,
    {
      refreshInterval: options.paused ? 0 : 30000,
      revalidateOnFocus: !options.paused,
    },
  )

  return {
    entries: Array.isArray(data) ? data : [],
    isLoading,
    isError: error,
    mutate,
  }
}

export default useShortlistEntries
